import { render, staticRenderFns } from "./SeminarTypeTab.vue?vue&type=template&id=2496bcd4"
import script from "./SeminarTypeTab.vue?vue&type=script&lang=js"
export * from "./SeminarTypeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports